// extracted by mini-css-extract-plugin
export default {"sectionBox":"styles_sectionBox__X50eD","danger":"styles_danger__4CLmD","marginTop":"styles_marginTop__AIi8F"};